<template>
  <div class="student-list-page">
    <div class="list-wrapper" v-if="list.length">
      <div class="student-box" v-for="(item, index) in list" :key="index" @click="toStudentInfo(item)">
        <div class="student-left">
          <img class="student-photo" :src="item.photo" v-if="item.photo">
          <div class="student-photo" v-else>{{item.name.slice(-2)}}</div>
          <div class="student-name">{{item.name}}</div>
          <div class="student-relationship">与学员关系：{{item.relation}}</div>
        </div>
        <div class="student-right"><van-icon name="arrow" size="18" color="#969799"/></div>
      </div>
    </div>
    <van-empty class="list-wrapper" description="没有学员哦~" image-size="128"
      image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png" v-else>
    </van-empty>
    <div class="footer">
      <van-button block square round type="primary"  @click="toAddStudent">新增</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'student-list',
  data() {
    return {
      pageTitle: '学员管理',
      list: [],
    }
  },
  computed: {
    
  },
  methods: {
    toAddStudent() {
      this.$router.push('/studentInfo');
    },
    toStudentInfo(item) {
      app.ls.set('parent-eidt-sutdentInfo', item);
      this.$router.push('/studentInfo?isEdit=true');
    },
    getStudents() {
      this.showLoading();
      this.$api.parentGetStudents().then(res=>{
        vant.Toast.clear();
        if (res.code === 200) {
          this.list = res.data;
        } else{
          this.$toast.fail(res.msg);
        }
      })
    }
  },
  created() {
    this.getStudents();
    this.$onBus("refresh-sutdent-list", ()=>{
      this.getStudents();
    });
  },
}
</script>


<style lang="scss" scoped>
.student-list-page {
  font-size: var(--fs-lg);
  display: flex;
  flex-direction: column;
  .list-wrapper {
    flex: 1;
    overflow-y: auto;
    .student-box {
      background-color: var(--white);
      padding: calc(var(--gap) * 16);
      display: flex;
      align-items: center;
      height: calc(var(--w) * 72);
      position: relative;
      .student-left {
        height: calc(var(--w) * 40);
        flex: 1;
        padding-left: calc(var(--gap) * 48);
        position: relative;
        .student-photo {
          position: absolute;
          left: 0;
          top: 0;
          width: calc(var(--w) * 40);
          height: calc(var(--w) * 40);
          line-height: calc(var(--w) * 40);
          border-radius: 50%;
          background-color: #FF8534;
          color: var(--white);
          text-align: center;
        }
        .student-name {
          margin-bottom: calc(var(--gap) * 2);
        }
        .student-relationship {
          font-size: var(--fs-sm);
          color: var(--g6);
        }
      }
      .student-right {
          
      }
      &:not(:last-child)::after {
        content: '';
        position: absolute;
        left: calc(var(--w) * 64);
        right: 0;
        bottom: 0;
        height: 1px;
        transform: scaleY(0.5);
        z-index: 10;
        background-color: var(--g3);
      }
    }
  }
  .footer {
    background-color: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    ::v-deep .van-button {
      height: calc(var(--w) * 40);
    }
  }
}
</style>